export const buildPromQLQueryFromUIDSAIDsMap = (
  gatewayId: string,
  uidSaids: Map<string, Set<number>>
): string | null => {
  const escapedGateway = gatewayId.replaceAll('"', String.raw`\"`);
  const queries: string[] = [];

  uidSaids.forEach((saidSet, uid) => {
    const escapedUid = String(uid).replaceAll('"', String.raw`\"`);
    const said = saidSet.size > 0 ? Math.min(...Array.from(saidSet)) : 0;
    const escapedSaid = String(said).replaceAll('"', String.raw`\"`);
    queries.push(
      `last_over_time(mqtt2tsdb_digitalinput_na{gateway="${escapedGateway}", uid="${escapedUid}", said="${escapedSaid}"}[30m])`
    );
  });

  if (queries.length === 0) {
    return null;
  }

  return queries.length > 1 ? queries.join(" OR ") : queries[0];
};

export const selectUIDSAIDsForUID = (
  uidSaids: Map<string, Set<number>>,
  uid?: string | null
): Map<string, Set<number>> => {
  if (!uid) {
    return new Map();
  }

  const selected = uidSaids.get(String(uid));
  if (!selected) {
    return new Map();
  }

  return new Map([[String(uid), selected]]);
};

